import React from 'react'

const RequestDeniedTemplate = ({ data }) => {
  const {
    studentName,
    roleName,
    companyName,
    placementOfficerName,
    placementOfficerContact
  } = data

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}>
      <p>Dear {studentName},</p>
      
      <p style={{ paddingTop: '8px' }}>
        I hope this message finds you well. Unfortunately, your request to apply for the {roleName} role 
        at {companyName} has been denied by the Placement Officer.
      </p>
      
      <p style={{ paddingTop: '8px' }}>
        For more information or clarification, please contact the Placement Officer.
      </p>
      
      <p style={{ paddingTop: '10px', paddingBottom: '2px', margin: '0px' }}>Best regards,</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{placementOfficerName}</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{placementOfficerContact}</p>
    </div>
  )
}

export default RequestDeniedTemplate
